import { useEffect } from 'react';
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
    const location = useLocation();
    const handleScrollToTop = () => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth',
        });
    };

    useEffect(() => {
        handleScrollToTop();
    }, [location]);

  return ''
}

export default ScrollTop;